module.exports = __webpack_public_path__ + "img/sch5-info.0372642b.png";